import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { getTeam } from '../../data';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Select, MenuItem, Button } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class SingleTeam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            team: [],
            loading: true,
            leagueID: this.props.match.params.leagueID,
            teamID: this.props.match.params.teamID,
        };
        this.renderGameWeekSelect = this.renderGameWeekSelect.bind(this);
        this.computeBalance = this.computeBalance.bind(this);
    }

    async componentDidMount() {
        const state = this.state;
        const data = await getTeam(state.leagueID, state.teamID);
        const scoreHeaders = Object.keys(data).filter(h => h.startsWith('gw'));
        const gw = scoreHeaders[0];
        this.setState(() => ({
            ...this.state,
            loading: false,
            data: data,
            team: gw === undefined ? [] : data[gw].players,
            gwScore: gw === undefined ? 0 : data[gw].score,
            balance: this.computeBalance(gw, data),
            gameWeek: gw,
            totalScore: data.totalScore,
        }));
    }

    handleGameWeekChange(e) {
        const gw = e.target.value;
        this.setState(() => ({
            ...this.state,
            team: this.state.data[gw].players,
            gwScore: this.state.data[gw].score,
            balance: this.computeBalance(gw, this.state.data),
            gameWeek: gw,
        }));
    }

    computeBalance(gw, data) {
        if (gw === undefined) {
            return '';
        }
        let balance = {
            'BAT': 0,
            'BOW': 0,
            'WK': 0,
        };
        data[gw].players.forEach(p => {
            if (p.pos === 'AR') {
                balance['BAT'] += 1;
                balance['BOW'] += 1;
            } else if (p.pos === 'WK') {
                balance['BAT'] += 1;
                balance['WK'] += 1;
            } else {
                balance[p.pos] += 1;
            }
        })
        return JSON.stringify(balance);
    }

    renderGameWeekSelect() {
        if (this.state.data === undefined) {
            return (<div></div>);
        }
        const gameWeeks = Object.keys(this.state.data).filter(k => k.toLowerCase().startsWith('gw'));
        const selectDropDown = gameWeeks.length !== 0 ? (
            <Select labelId="choose gameweek" id='gameweek' value={this.state.gameWeek || gameWeeks[0]}
                onChange={(e) => this.handleGameWeekChange(e)}>
                {gameWeeks.map(gw => {
                    return <MenuItem key={gw} value={gw}>{gw.toUpperCase()}</MenuItem>
                })}
            </Select>
        ): (<div></div>)
        return (
            <TableRow key={'gameweek'}>
                <TableCell>GameWeek</TableCell>
                <TableCell>&nbsp;&nbsp;</TableCell>
                <TableCell>{selectDropDown}</TableCell>
            </TableRow>
        );
    }

    render() {
        return (
            <div style={{ 'display': 'flex', 'justifyContent': 'center', 'flexWrap': 'wrap', 'marginBottom': '50px', 
                'maxWidth': '600px', 'marginLeft': 'auto', 'marginRight': 'auto'}}>
                <Link to={`/leagues/${this.state.leagueID}`} style={{marginTop: '5px', 'flexGrow': 0}} >
                    <ArrowBackIcon />
                </Link>
                <Typography variant="h5" style={{'flexGrow': 1}}>
                    {this.state.teamID}
                </Typography>
                {this.state.loading && (
                    <div style={{'flexBasis': '100%'}}>
                        <CircularProgress />
                        <br />
                    </div>
                )}
                {
                    <div style={{display: 'flex-item', flexBasis: '100%', marginBottom: 20, marginTop: 20}}>
                    <Link to={`/leagues/${this.state.leagueID}/teams/${this.state.teamID}/squad`} style={{width: 200}}>
                    <Button variant='contained'>
                        Squad View
                    </Button>
                    </Link>
                    {this.state?.data?.isOwner &&
                    <Link to={`/leagues/${this.state.leagueID}/teams/${this.state.teamID}/captains`}
                        style={{width: 200, marginLeft: 20}}>
                    <Button variant='contained'>
                        Captains
                    </Button>
                    </Link>}
                    </div>
                }
                <TableContainer component={Paper} style={{ alignSelf: 'center', flex: 'auto', 'maxWidth': '600px'}}>
                    <Table>
                        <TableBody>
                            {this.state.totalScore !== undefined && <TableRow key={'totalScore'}>
                                <TableCell>Total Score</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.totalScore}</TableCell>
                            </TableRow>}
                            {this.renderGameWeekSelect()}
                            {this.state.gwScore !== undefined && <TableRow key={'gwScore'}>
                                <TableCell>GW Score</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.gwScore}</TableCell>
                            </TableRow>}
                            {this.state.gwScore !== undefined && <TableRow key={'balance'}>
                                <TableCell>Balance</TableCell>
                                <TableCell>&nbsp;&nbsp;</TableCell>
                                <TableCell>{this.state.balance}</TableCell>
                            </TableRow>}
                            {this.state.gwScore !== undefined && <TableRow key={'divider'}>
                                <TableCell>-----</TableCell>
                                <TableCell>-----</TableCell>
                                <TableCell>-----</TableCell>
                            </TableRow>}
                            {this.state.team.map((player, i) => (
                                <TableRow key={i}>
                                    <TableCell>{player.name + (player.matchScores.length > 0 ? player.matchScores.map(o => o.captain ? ' (c) ' : '').reduce((p, c) => p + ',' + c) : '')}</TableCell>
                                    <TableCell>{` (${player.team} - ${player.pos})`}</TableCell>
                                    <TableCell>{player.matchScores.length > 0 ? player.matchScores.map(o => o.score).reduce((p, c) => p + ',' + c) : ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}
export default withRouter(SingleTeam);